import {$http} from '../request'
import API from '@/api'

const INTERVAL_TIME = 5000

const $statistics = () => {
  const fn = {}

  // 开始统计页面时长
  fn.startBrowse = ({ openid, token, activityId, type = 1 } = {}) => {
    (function statisticsBrowse() {
      $http({
        url: API.browse,
        method: 'POST',
        params: {
          openid,
          token,
          type,
          activity_id: activityId
        }
      })
      
      // if (type++ < 15) {
      //   setTimeout(statisticsBrowse, INTERVAL_TIME)
      // }
    })()
  }

  fn.addBehavior = ({ openid, token, uid, pid, activityId, type = 10, extra = '' }) => {
    return $http({
      url: API.addBehavior,
      method: 'POST',
      params: {
        openid,
        token,
        type,
        pid,
        user_id: uid,
        activity_id: activityId,
        extra
      }
    })
  }

  /**
   * 分享成功 回调发送请求
   *
   * @param {string} action pv uv share_line share_friend
   * @param {string} activityId 活动id
   * @param {string} uid other_uid
   */
  fn.action = ({ activityId, uid, openid, token, action = 'pv' } = {}) => {
    return $http({
      url: API.statistics,
      method: 'POST',
      params: {
        activity_id: activityId,
        user_id: uid,
        action,
        openid,
        token
      }
    })
  }

  return fn
}
const statisticsPlugin = Vue => {
  Vue.prototype.$statistics = $statistics()
}
export default statisticsPlugin